import { Platform } from '#src/__generated__/globalTypes.ts';

import { useIsMobileApp } from './useIsMobileApp.ts';

export const usePlatform = () => {
  const { isAndroidApp, isIosApp } = useIsMobileApp();
  if (isAndroidApp) return Platform.ANDROID;
  if (isIosApp) return Platform.IOS;
  return Platform.WEB;
};
